import React from 'react';
import PropTypes from 'prop-types';

function OptimizeChip({
  children, onClose
}) {
  return (
    <div
      className="filterTagShipments"
    >
      <p style={{
        width: '90%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        marginBottom: 0
      }}
      >
        {children}
      </p>
      {onClose && (
      <div
        style={{
          marginLeft: 16,
          cursor: 'pointer'
        }}
        onClick={onClose}
      >
        &#x2715;
      </div>
      )}
    </div>
  );
}

OptimizeChip.defaultProps = {
  onClose: undefined
};

OptimizeChip.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default OptimizeChip;
